import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('sheet_rate_identifiers', '/sheet_rates_identifiers')
const actions = generator.generate()

export default actions
